import { PARTNER_ROW_COMPONENTS } from '@organisms/PartnerRows/PartnerRow.constants';
import { HERO_COMPONENTS } from '@organisms/HeroBanners/HeroBanner.constants';

export const getCategoryPageProps = (dynamicProps: DynamicProps): object => {
    const props = dynamicProps.CategoryPage;
    return {
        CategoryPage: {
            ...props,
            partnerRowType:
                props.partnerRowType === 'LegacyPartnerRow'
                    ? PARTNER_ROW_COMPONENTS.PartnerRowAlpha
                    : props.partnerRowType,
            heroType:
                props.heroType === 'LegacyHeroBanner'
                    ? HERO_COMPONENTS.HeroBannerAlpha
                    : props.heroType,
        },
    };
};
